import React, { useState, useEffect } from "react";
import axios from "axios";

const SourceCode = () => {
  const [form, setForm] = useState({
    tollFreeNumber: "",
    sourceCode: "",
    isActive: "false",
  });

  const [list, setList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [editId, setEditId] = useState(null);

  // ✅ Fetch all source codes
  useEffect(() => {
    fetchSourceCodes();
  }, []);

  const fetchSourceCodes = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/sourceCodes");
      setList(res.data);
    } catch (err) {
      console.error("Error fetching source codes:", err);
    }
  };

  // ✅ Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  // ✅ Save new source code
  const handleSave = async () => {
    if (!form.tollFreeNumber || !form.sourceCode) {
      alert("⚠️ Please fill all fields");
      return;
    }
    try {
      const res = await axios.post("https://crm-server-htk6.vercel.app/api/sourceCodes", form);
      if (res.data.success) {
        alert("✅ Source Code saved successfully");
        fetchSourceCodes();
        resetForm();
      }
    } catch (err) {
      console.error("❌ Error saving source code:", err);
    }
  };

  // ✅ Edit source code
  const handleEdit = (row) => {
    setForm({
      tollFreeNumber: row.tollFreeNumber,
      sourceCode: row.sourceCode,
      isActive: row.isActive,
    });
    setEditId(row._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Update source code
  const handleUpdate = async () => {
    if (!form.tollFreeNumber || !form.sourceCode) {
      alert("⚠️ Please fill all fields");
      return;
    }
    try {
      await axios.put(`https://crm-server-htk6.vercel.app/api/sourceCodes/${editId}`, form);
      alert("✨ Source Code updated successfully");
      fetchSourceCodes();
      resetForm();
    } catch (err) {
      console.error("❌ Error updating source code:", err);
    }
  };

  // ✅ Reset form
  const resetForm = () => {
    setForm({
      tollFreeNumber: "",
      sourceCode: "",
      isActive: "false",
    });
    setEditId(null);
  };

  // ✅ Delete single source code
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this Source Code?")) return;
    try {
      await axios.delete(`https://crm-server-htk6.vercel.app/api/sourceCodes/${id}`);
      fetchSourceCodes();
      setSelected((prev) => prev.filter((s) => s !== id));
    } catch (err) {
      console.error("❌ Error deleting source code:", err);
    }
  };

  // ✅ Bulk delete
  const handleBulkDelete = async () => {
    if (selected.length === 0) {
      alert("⚠️ Please select at least one Source Code to delete");
      return;
    }
    if (!window.confirm(`Delete ${selected.length} selected Source Codes?`)) return;

    try {
      await axios.delete("https://crm-server-htk6.vercel.app/api/sourceCodes", {
        data: { ids: selected },
      });
      setSelected([]);
      fetchSourceCodes();
    } catch (err) {
      console.error("❌ Error bulk deleting source codes:", err);
    }
  };

  // ✅ Toggle single selection
  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  // ✅ Select all
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelected(list.map((row) => row._id));
    } else {
      setSelected([]);
    }
  };

  return (
    <div className="page" style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
      <h2 style={{ textAlign: "center", color: "#2a9d8f" }}>Source Code Management</h2>

      {/* Form */}
      <div
        className="form-container"
        style={{
          background: "#f8f9fa",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        <h3 style={{ marginBottom: "15px", color: "#264653" }}>
          {editId ? "✏️ Update Source Code" : "➕ Add New Source Code"}
        </h3>

        <div className="form-row" style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
          <input
            type="text"
            name="tollFreeNumber"
            placeholder="Toll Free Number"
            value={form.tollFreeNumber}
            onChange={handleChange}
            style={{ flex: 2, padding: "8px" }}
          />
          <input
            type="text"
            name="sourceCode"
            placeholder="Source Code"
            value={form.sourceCode}
            onChange={handleChange}
            style={{ flex: 2, padding: "8px" }}
          />
          <select
            name="isActive"
            value={form.isActive}
            onChange={handleChange}
            style={{ flex: 1, padding: "8px" }}
          >
            <option value="false">Active - False</option>
            <option value="true">Active - True</option>
          </select>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={editId ? handleUpdate : handleSave}
            style={{
              background: editId ? "#e9c46a" : "#2a9d8f",
              color: "white",
              padding: "10px 16px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              flex: 1,
            }}
          >
            {editId ? "✏️ Update Source Code" : "💾 Save Source Code"}
          </button>

          {editId && (
            <button
              onClick={resetForm}
              style={{
                background: "#e63946",
                color: "white",
                padding: "10px 16px",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer",
                flex: 1,
              }}
            >
              ❌ Cancel
            </button>
          )}
        </div>
      </div>

      {/* Header with Bulk Delete */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        <h3 style={{ margin: 0 }}>📋 Source Code List</h3>
        <button
          onClick={handleBulkDelete}
          style={{
            background: selected.length > 0 ? "#e63946" : "gray",
            color: "white",
            padding: "8px 16px",
            borderRadius: "6px",
            border: "none",
            cursor: selected.length > 0 ? "pointer" : "not-allowed",
          }}
          disabled={selected.length === 0}
        >
          🗑 Delete Selected ({selected.length})
        </button>
      </div>

      {/* Table */}
      <div className="table-container" style={{ overflowX: "auto" }}>
        <table className="user-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f4f4f4" }}>
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={list.length > 0 && selected.length === list.length}
                />
              </th>
              <th>Toll Free Number</th>
              <th>Source Code</th>
              <th>Active</th>
              <th>Log Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "12px" }}>
                  No records found
                </td>
              </tr>
            ) : (
              list.map((row) => (
                <tr key={row._id} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ textAlign: "center" }}>
                    <input
                      type="checkbox"
                      checked={selected.includes(row._id)}
                      onChange={() => toggleSelect(row._id)}
                    />
                  </td>
                  <td>{row.tollFreeNumber}</td>
                  <td>{row.sourceCode}</td>
                  <td>{row.isActive === "true" ? "Yes" : "No"}</td>
                  <td>{new Date(row.logDate).toLocaleDateString()}</td>
                  <td style={{ textAlign: "center" }}>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                      <button
                        onClick={() => handleEdit(row)}
                        style={{
                          background: "#457b9d",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        ✏️ Edit
                      </button>
                      <button
                        onClick={() => handleDelete(row._id)}
                        style={{
                          background: "#e63946",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          cursor: "pointer",
                        }}
                      >
                        🗑 Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SourceCode;
